import { render, staticRenderFns } from "./ValueObjectEditorJT.vue?vue&type=template&id=135c4426&"
import script from "./ValueObjectEditorJT.vue?vue&type=script&lang=js&"
export * from "./ValueObjectEditorJT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports